<template>
  <div class="dashboard-container">
    <div class="bg">
      <!-- 导航栏 -->
      <Nav title="客流趋势" @getTime="getTime" @address="address" class="nav-wrapper"/>
      <div style="flex: 1;display: flex;flex-direction: column;justify-content: space-evenly">
        <div class="totalList">
          <div>
            <el-button v-for="(i,index) in provinceList" size="mini" :class="{active: i.index === currentProvince}"
                       @click="provinceChoose(i.index)" :key="index">{{ i.title }}
            </el-button>
          </div>
        </div>
        <div class="first-child">
          <div style="height: 5%;display: flex;justify-content: space-between;align-items: center">
            <div v-if="getTimes">
              对比时间:{{ getTimes[0] }} -- {{ getTimes[1] }}
            </div>
            <div style="height: 100%" v-else>暂无对比时间</div>
            <div class="totalList" style="width: 10%;height: 100%;padding: 0;">
              <el-button v-for="(i,index) in dateList" size="mini" :class="{active: i.index === currentDate}"
                         @click="dateChoose(i.index)" :key="index">{{ i.title }}
              </el-button>
            </div>
          </div>
          <div class="first-child-left">
            <div style="width: 15%">
              <div style="width: 100%;display: flex;justify-content: space-between;text-align: center">
                <div :class="{isBlack: isType===1 }"
                     style="background-color:rgba(255,255,255,0.3);padding: 5px 10px;width: 33%" @click="isType=1">区域
                </div>
                <div :class="{isBlack: isType===2 }"
                     style="background-color:rgba(255,255,255,0.3);padding: 5px 10px;width: 33%" @click="isType=2">时间
                </div>
                <div :class="{isBlack: isType===3 }"
                     style="background-color:rgba(255,255,255,0.3);padding: 5px 10px;width: 33%" @click="isType=3">列表
                </div>
              </div>
              <div v-if="isType===1" style="width: 100%;background-color:rgb(17, 27, 39);border-radius: 12px;">
                <div class="selected-container">
                  <h4>对比区域：</h4>
                  <div v-if="selectedItems.length === 0" class="placeholder">
                    暂无选中项
                  </div>
                  <div v-else class="selected-list">
                    <div
                        v-for="(item, index) in selectedItems"
                        :key="item.value"
                        class="selected-item">
                      <span>{{ item.name }}</span>
                      <el-button
                          icon="el-icon-close"
                          circle
                          size="mini"
                          @click="removeSelectedItem(index)"
                          style="margin-left: 10px; background-color: #291111; color: white"
                      ></el-button>
                    </div>
                  </div>
                  <div>
                    <el-button icon="el-icon-plus" @click="taskadd" style="background-color:rgb(34,53,76);width: 100%;">
                      新增
                    </el-button>
                  </div>
                </div>

              </div>
              <div v-if="isType===2" style="width: 100%;background-color:rgb(17, 27, 39);border-radius: 12px;">
                <div class="selected-container">
                  <h4>对比时间段：</h4>
                  <div v-if="selectedTimeRanges.length === 0" class="placeholder">
                    暂无时间段
                  </div>
                  <div v-else class="selected-list">
                    <div
                        class="selected-item">
                      <span>{{ selectedTimeRanges[0] }}---{{ selectedTimeRanges[1] }}</span>
                      <el-button
                          icon="el-icon-close"
                          circle
                          size="mini"
                          @click="removeTimeRange"
                          style="margin-left: 10px; background-color: #291111; color: white"
                      ></el-button>
                    </div>
                  </div>
                  <div>
                    <el-button icon="el-icon-plus" @click="timeadd" style="background-color:rgb(34,53,76);width: 100%;">
                      新增
                    </el-button>
                  </div>
                </div>
              </div>
              <div v-if="isType===3">
                <div class="selected-container">
                  <div
                      v-for="(i, index) in CompareList"
                      :key="index"
                      style="margin: 2px 0;"
                      class="selected-item"

                  >
                    <div
                        @click="getTouristTrendByCompareId(i)"
                        style="
    display: flex;
    flex-direction: column;
    gap: 4px; /* 上下间距 */
    padding: 8px 12px; /* 内边距 */
    width: 80%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer; /* 鼠标悬停手势 */
    border-radius: 4px; /* 圆角 */
    background: rgba(255, 255, 255, 0.05); /* 浅色背景 */
    transition: all 0.2s ease; /* 悬停动画 */
  ">
                      <!-- 时间范围（加粗 + 小字号） -->
                      <div style="font-size: 12px; color: #aaa; font-weight: 500;">
                        {{ i.start_time }} 至 {{ i.end_time }}
                      </div>

                      <!-- POI 名称（突出显示） -->
                      <div style="font-size: 14px; font-weight: 600; color: #fff;">
                        {{ i.poi_name1 }} → {{ i.poi_name2 }}
                      </div>
                    </div>
                    <el-button
                        icon="el-icon-close"
                        circle
                        size="mini"
                        @click="deleteCompare(i.id)"
                        style="margin-left: 10px; background-color: #291111; color: white"
                    ></el-button>
                  </div>
                </div>
              </div>
              <div style="margin-top: 10px">
                <el-button @click="startContrast">添加</el-button>
              </div>

            </div>
            <div style="width: 80%;height: 100%;overflow: hidden">
              <div class="box-flex-col">
                <div style="height: 10%;">
                  <div>天气</div>
                  <div style="display: flex;justify-content: space-between;font-size: 10px;padding: 0 5px">
                    <div v-for="(i,index) in getTouristTrend[0].list" :key="index">
                      <img style="width: 20px;height: 20px" v-if="i.weather == 1"
                           src="@/image/passengerFlowTrend/muzhishang.png" alt="">
                      <img style="width: 20px;height: 20px" v-else src="@/image/passengerFlowTrend/muzhixia.png" alt="">
                    </div>
                  </div>
                </div>
                <div style="height: 10%">
                  <div>节假日</div>
                  <div style="display: flex;justify-content: space-between;font-size: 10px;padding: 0 5px">
                    <div v-for="(i,index) in getTouristTrend[0].list" :key="index">
                      <span v-if="i.holidayName!= null">{{ i.holidayName }}</span>
                    </div>
                  </div>
                </div>
                <div style="height: 10%">
                  <div>星期</div>
                  <div style="display: flex;justify-content: space-between;font-size: 10px;padding: 0 5px">
                    <div v-for="(i,index) in getTouristTrend[0].list" :key="index">
                      {{ i.week }}
                    </div>
                  </div>
                </div>
                <div style="height: 10%">
                  <div>事件</div>
                  <div style="display: flex;justify-content: space-between;font-size: 10px;padding: 0 5px">
                    <div v-for="(i,index) in getTouristTrend[0].list" :key="index">
                      {{ i.event }}
                    </div>
                  </div>
                </div>
                <div style="height: 50%;">
                  <div id="TrendByCompareId" style="width: 100%;height: 100%"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="second-child">
          <div style="background-color: rgb(17, 27, 39);width: 49%;display: flex;justify-content: space-between">
            <div style="height: 100%;width: 33%;text-align: center;display: flex;flex-direction: column">
              <div class="backGround-line">区县客流</div>
              <div id="District" style="width: 100%;height:60%;"></div>
              <div class="chart-footer">
                <div class="data-item">
                  <span class="label">本区县客流</span>
                  <div>
        <span class="value highlight">
          {{ getFlowStructureArea[1].count }}
        </span>
                    <span class="rate">
          {{ getFlowStructureArea[1].percentage }}%
        </span>
                  </div>
                </div>
                <div class="data-item">
                  <span class="label">外区县客流</span>
                  <div>
        <span class="value">
          {{ getFlowStructureArea[0].count }}
        </span>
                    <span class="rate">
          {{ getFlowStructureArea[0].percentage }}%
        </span>
                  </div>
                </div>
              </div>
            </div>

            <div style="height: 100%;width: 33%;text-align: center;display: flex;flex-direction: column">
              <div class="backGround-line">市客流</div>
              <div id="cityLevel" style="width: 100%;height: 60%;"></div>
              <div class="chart-footer">
                <div class="data-item">
                  <span class="label">市客流</span>
                  <div>
        <span class="value highlight">
          {{ getFlowStructureCity[0].count }}
        </span>
                    <span class="rate">
          {{ getFlowStructureCity[0].percentage }}%
        </span>
                  </div>
                </div>
                <div class="data-item">
                  <span class="label">市客流</span>
                  <div>
        <span class="value">
          {{ getFlowStructureCity[1].count }}
        </span>
                    <span class="rate">
          {{ getFlowStructureCity[1].percentage }}%
        </span>
                  </div>
                </div>
              </div>
            </div>
            <div style="height: 100%;width: 33%;text-align: center;display: flex;flex-direction: column">
              <div class="backGround-line">省客流</div>
              <div id="provincialLevel" style="width: 100%;height: 60%;"></div>
              <div class="chart-footer">
                <div class="data-item">
                  <span class="label">省客流</span>
                  <div>
        <span class="value highlight">
          {{ getFlowStructureProv[0].count }}
        </span>
                    <span class="rate">
          {{ getFlowStructureProv[0].percentage }}%
        </span>
                  </div>
                </div>
                <div class="data-item">
                  <span class="label">省客流</span>
                  <div>
        <span class="value">
          {{ getFlowStructureProv[1].count }}
        </span>
                    <span class="rate">
          {{ getFlowStructureProv[1].percentage }}%
        </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="background-color: rgb(17, 27, 39);width: 49%">
            <div class="backGround-line">分项汇总</div>
            <div style="height: 90%;width: 100%">
              <dataTable style="height: 100%" :columns="colBase" :data="dataBase" :roll="true"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 区域选择抽屉 -->
    <el-drawer
        title="区域选择"
        :visible.sync="drawer"
        direction="rtl"
        style="z-index: 99999999999"
        size="20%"
        :with-header="false">
      <div class="drawer-content">
        <div class="grid-left-elDrawer">
          <el-button
              v-for="item in compareRegions"
              :key="item.value"
              :class="{ active: selectedItems.includes(item) }"
              @click="toggleSelect(item)"
              :disabled="selectedItems.length >= 2 && !selectedItems.includes(item)"
          >
            {{ item.name }}
          </el-button>
        </div>
        <div class="selection-count">
          已选中：{{ selectedItems.length }} / 2 个
        </div>
      </div>
    </el-drawer>

    <!-- 时间选择抽屉 -->
    <el-drawer
        title="时间选择"
        :visible.sync="timeDrawer"
        direction="rtl"
        style="z-index: 99999999999"
        size="30%"
        :with-header="false">
      <div class="drawer-content">
        <div style="padding: 20px;">
          <el-date-picker
              v-model="tempTimeRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>

          <el-button
              type="primary"
              @click="addTimeRange"
              style="width: 100%;"
              :disabled="!tempTimeRange || tempTimeRange.length !== 2"
          >
            添加时间段
          </el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Nav from '_c/Nav/Nav.vue'
import dataTable from "_c/dataTable/dataTable.vue";
import * as echarts from 'echarts'
import {
  touristFlowTrendAddCompare,
  touristFlowTrendDeleteCompare,
  touristFlowTrendGetCompareList,
  touristFlowTrendGetPoiList,
  touristFlowTrendGetTouristTrendByCompareId,
  touristFlowTrendGetFlowStructure,
  touristFlowTrendGetItemSummary
} from '@/request/passengerFlowTrend/passengerFlowTrend'

export default {
  components: {Nav, dataTable},
  data() {
    return {
      chart_1: null, // 事件趋势图实列
      chart_2: null, // 区县级
      chart_3: null, // 市级
      chart_4: null,  // 县级
      colBase: [{label: '项目', prop: 'name'},
        {label: "说明", prop: 'desc'},
        {label: '客流', prop: 'count',},
        {label: '分项占比', prop: 'rate', type: 'satisfaction'},],  // 表格的参数名字
      dataBase: [], //  表格数据
      form: {}, // 参数数据
      getTimes: '', // 对比的时间
      selectedItems: [], // 存储选中的区域
      nameid: [], // 名字的id
      compareRegions: [], // 对比区域的数据
      drawer: false, // 控制区域遮罩
      timeDrawer: false, // 控制时间遮罩
      isType: 1, // 选择区域和时间的切换栏
      selectedTimeRanges: '', // 存储选中的时间段
      tempTimeRange: [], // 临时存储选择的时间段
      CompareList: [],// 对比的列表
      getTouristTrend: [{}, {}], // 存储对比之后的数据
      // 本区县 省份城市
      provinceList: [{title: '全部', index: ''}, {title: '本区县', index: '1'}, {
        title: '外区县',
        index: '2'
      }, {title: '本市', index: '3'}, {title: '外市', index: '4'}, {title: '本省', index: '5'}, {
        title: '外省',
        index: '6'
      }],
      dateList: [{title: '日', index: '1'}, {title: '周', index: '2'}, {title: '月', index: '3'}, {
        title: '年',
        index: '4'
      }],
      currentProvince: '1',  // 标记被选中的状态城市 省份
      currentDate: '1', // 标记被选中的状态 天周月年
      getFlowStructureArea: [{}, {}],// 存储区县
      getFlowStructureCity: [{}, {}],// 存储 市
      getFlowStructureProv: [{}, {}],// 存储 省级数据
    }
  },
  methods: {
    // 加载区县级的echart
    area() {
      touristFlowTrendGetFlowStructure().then(res => {
        this.getFlowStructureArea = res.data.data.area
        this.getFlowStructureCity = res.data.data.city
        this.getFlowStructureProv = res.data.data.prov
        const area = ['外区县', '本区县']
        const city = ['本市', '外市']
        const prov = ['本省', '外省']
        for (let i = 0; i < area.length; i++) {
          this.getFlowStructureArea[i].name = area[i]
        }
        for (let i = 0; i < city.length; i++) {
          this.getFlowStructureCity[i].name = city[i]
        }
        for (let i = 0; i < prov.length; i++) {
          this.getFlowStructureProv[i].name = prov[i]
        }

        let data = this.getFlowStructureArea.map(item => ({
          value: item.count,
          name: item.name,
        }))
        let data1 = this.getFlowStructureCity.map(item => ({
          value: item.count,
          name: item.name,
        }))
        let data2 = this.getFlowStructureProv.map(item => ({
          value: item.count,
          name: item.name,
        }))
        let color = ["#FF5733", "#3357FF",];
        this.chart_2.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: color,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['30%', '60%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 5,
                lineHeight: 5,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 5,
                length2: 5,
                maxSurfaceAngle: 80
              },
              data: data
            }
          ]
        })
        this.chart_3.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: color,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['30%', '60%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 5,
                lineHeight: 5,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 5,
                length2: 5,
                maxSurfaceAngle: 80
              },
              data: data1
            }
          ]
        })
        this.chart_4.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: color,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['30%', '60%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 5,
                lineHeight: 5,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 5,
                length2: 5,
                maxSurfaceAngle: 80
              },
              data: data2
            }
          ]
        })

      })
    },

    // 区域相关方法
    taskadd() {
      this.drawer = true
    },
    removeSelectedItem(index) {
      this.selectedItems.splice(index, 1);
    },
    // 获取趋势列表
    async getTouristTrendByCompareId(item) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.chart_1 = echarts.init(document.getElementById('TrendByCompareId'));
      this.form = {
        areaType: this.currentProvince,
        id: item.id,
        dateType: this.currentDate
      }
      await touristFlowTrendGetTouristTrendByCompareId(this.form).then(res => {
        console.log(res)
        if (res.data.data) {
          this.getTouristTrend = res.data.data
          const legend = res.data.data.map(item => {
            return item.name
          });
          var colors = [
            "#FF5733",
            "#33FF57",
            "#3357FF",
            "#FF33A1",
            "#9033FF",
            "#33FFF6",
            "#FFBD33",
            "#FF3333",
            "#FFFFFF"
          ];
          // 时间段
          var xAxisData = res.data.data[0].list.map(item => {
            return item.date
          })
          const updateChart = () => {
            var list = []
            for (let i = 0; i < legend.length; i++) {
              var obj = {
                name: legend[i],
                type: 'line',
                itemStyle: {color: colors[i]},
                label: {show: false},
                data: res.data.data[i].list.map(item => {
                  return item.sum
                })
              }
              list.push(obj)
            }
            return list
          }
          this.chart_1.setOption({
            grid: {
              top: 20,
              bottom: 20,
              left: 30,
              right: 10
            },
            tooltip: {
              trigger: 'axis',
              position: function (pt) {
                return [pt[0], '25%'];
              }
            },
            legend: {
              data: legend,
              textStyle: {
                color: '#fff',
              }
            },
            toolbox: {
              show: false,
              feature: {
                dataView: {readOnly: false},
                magicType: {type: ['line', 'bar']},
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: xAxisData
            },
            yAxis: {
              type: 'value',
            },
            series: updateChart()
          })
        }
      })
      loading.close();
    },
    // 开始对比
    async startContrast() {
      console.log(this.selectedItems);
      const form = {
        compareStartTime: this.selectedTimeRanges[0],
        compareEndTime: this.selectedTimeRanges[1],
        poiId1: this.selectedItems[0].id,
        poiId2: this.selectedItems[1].id,
      }
      touristFlowTrendAddCompare(form).then(res => {
        if (res.data.code == 0) {
          this.$message.error(res.data.msg);
          return
        }
        if (res.data.code == 1) {
          this.$message.success('添加成功');
          touristFlowTrendGetCompareList().then(res => {
            this.CompareList = res.data.data
          })
        }

      })
    },
    // 选择区域
    toggleSelect(item) {
      const index = this.selectedItems.findIndex(i => i.id === item.id);
      if (index > -1) {
        this.selectedItems.splice(index, 1);
      } else {
        if (this.selectedItems.length < 2) {
          this.selectedItems.push(item);
        }
      }
    },

    // 删除对比分析
    async deleteCompare(value) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      await touristFlowTrendDeleteCompare({id: value}).then(async res => {
        if (res.data.code == 1) {
          await touristFlowTrendGetCompareList().then(res => {
            this.CompareList = res.data.data
          })
          this.$message.success("删除成功");
        }
      })
      loading.close();
    },
    // 时间相关方法
    timeadd() {
      this.timeDrawer = true
    },

    // 添加时间段
    addTimeRange() {
      function formatDateToYMD(date) {
        const y = date.getFullYear().toString();
        const m = ('0' + (date.getMonth() + 1)).slice(-2);
        const d = ('0' + date.getDate()).slice(-2);
        return `${y}-${m}-${d}`;
      }

      this.selectedTimeRanges = this.tempTimeRange.map(date => formatDateToYMD(date));
    },
    // 删除时间
    removeTimeRange() {
      this.selectedTimeRanges = ''
    },

    // 左上角切换区域触发
    provinceChoose(value) {
      this.currentProvince = value
    },
    // 右上角切换年月触发
    async dateChoose(value) {
      this.currentDate = value
      this.form.dateType = value
      await touristFlowTrendGetTouristTrendByCompareId(this.form).then(res => {
        try {
          if (res.data.data) {
            console.log(111111)
            this.getTouristTrend = res.data.data
            const legend = res.data.data.map(item => {
              return item.name
            });
            var colors = [
              "#FF5733",
              "#33FF57",
              "#3357FF",
              "#FF33A1",
              "#9033FF",
              "#33FFF6",
              "#FFBD33",
              "#FF3333",
              "#FFFFFF"
            ];
            // 时间段
            var xAxisData = res.data.data[0].list.map(item => {
              return item.date
            })
            const updateChart = () => {
              var list = []
              for (let i = 0; i < legend.length; i++) {
                var obj = {
                  name: legend[i],
                  type: 'line',
                  itemStyle: {color: colors[i]},
                  label: {show: false},
                  data: res.data.data[i].list.map(item => {
                    return item.sum
                  })
                }
                list.push(obj)
              }
              return list
            }
            this.chart_1.setOption({
              grid: {
                top: 20,
                bottom: 20,
                left: 30,
                right: 10
              },
              tooltip: {
                trigger: 'axis',
                position: function (pt) {
                  return [pt[0], '25%'];
                }
              },
              legend: {
                data: legend,
                textStyle: {
                  color: '#fff',
                }
              },
              toolbox: {
                show: false,
                feature: {
                  dataView: {readOnly: false},
                  magicType: {type: ['line', 'bar']},
                  saveAsImage: {}
                }
              },
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: xAxisData
              },
              yAxis: {
                type: 'value',
              },
              series: updateChart()
            })
          }
        } catch (err) {
          console.error(err)
        }
      })
    },
    // 共用方法
    getTime(value) {
      this.getTimes = value;
      this.form.startTime = value[0]
      this.form.endTime = value[1]
      //  区县 市级 省级
      touristFlowTrendGetFlowStructure(this.form).then(res => {
        this.getFlowStructureArea = res.data.data.area
        this.getFlowStructureCity = res.data.data.city
        this.getFlowStructureProv = res.data.data.prov
        const area = ['外区县', '本区县']
        const city = ['本市', '外市']
        const prov = ['本省', '外省']
        for (let i = 0; i < area.length; i++) {
          this.getFlowStructureArea[i].name = area[i]
        }
        for (let i = 0; i < city.length; i++) {
          this.getFlowStructureCity[i].name = city[i]
        }
        for (let i = 0; i < prov.length; i++) {
          this.getFlowStructureProv[i].name = prov[i]
        }

        let data = this.getFlowStructureArea.map(item => ({
          value: item.count,
          name: item.name,
        }))
        let data1 = this.getFlowStructureCity.map(item => ({
          value: item.count,
          name: item.name,
        }))
        let data2 = this.getFlowStructureProv.map(item => ({
          value: item.count,
          name: item.name,
        }))
        let color = ["#FF5733", "#3357FF",];
        this.chart_2.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: color,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['30%', '60%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 5,
                lineHeight: 5,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 5,
                length2: 5,
                maxSurfaceAngle: 80
              },
              data: data
            }
          ]
        })
        this.chart_3.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: color,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['30%', '60%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 5,
                lineHeight: 5,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 5,
                length2: 5,
                maxSurfaceAngle: 80
              },
              data: data1
            }
          ]
        })
        this.chart_4.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: color,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['30%', '60%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 5,
                lineHeight: 5,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 5,
                length2: 5,
                maxSurfaceAngle: 80
              },
              data: data2
            }
          ]
        })

      })
      // 分项占比
      touristFlowTrendGetItemSummary(this.form).then(res => {
        this.dataBase = res.data.data
      })
    },
    address(value) {
      console.log('地址筛选:', value)
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.chart_2 = echarts.init(document.getElementById('District'))
      this.chart_3 = echarts.init(document.getElementById('cityLevel'))
      this.chart_4 = echarts.init(document.getElementById('provincialLevel'))
    })
  },
  async created() {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    // 获取景点列表
    await touristFlowTrendGetPoiList().then(res => {
      this.compareRegions = res.data.data
    })
    // 获取对比列表
    await touristFlowTrendGetCompareList().then(res => {
      this.CompareList = res.data.data
    })
    // 获取分项占比
    await touristFlowTrendGetItemSummary().then(res => {
      this.dataBase = res.data.data
    })
    // 区县 市 省数据
    await this.area()

    loading.close();
  }
}
</script>

<style scoped lang="scss">
/* 保持原有的样式不变，新增样式可以根据需要添加 */
.dashboard-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

* {
  color: #fff;
}

.totalList {
  width: 80%;
  padding: 10px 0;
  display: flex;
  height: 6%;
  justify-content: space-between;
  gap: 10px;
  //background-color: rgba(0, 0, 0, 0.3);
  border-radius: 4px;

  > div {
    display: flex;
    flex-wrap: nowrap;
    gap: 8px;
    justify-content: flex-end;
  }

  .el-button {
    margin: 0 !important;
    padding: 6px 12px;
    font-size: 12px;
    border-radius: 4px;
    transition: all 0.3s ease;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;

    &:hover {
      background-color: rgba(64, 158, 255, 0.7);
      transform: translateY(-2px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }

    &.is-active, &.active {
      background-color: #409EFF;
      color: #fff;
      font-weight: bold;
    }
  }
}

.bg {
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  padding: 16px 16px 0 16px;
  background-image: url("../../assets/pageBg.png");
  background-size: cover;
  background-position: center center;
  box-sizing: border-box;
  overflow-x: hidden;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
}

.first-child {
  width: 100%;
  height: 60%;
  padding: 10px;
  background-color: rgb(17, 27, 39);
  overflow: hidden;
}

.second-child {
  width: 100%;
  height: 30%;
  display: flex;
  justify-content: space-between;
}

.first-child-left {
  width: 100%;
  display: flex;
  height: 95%;
  justify-content: space-between;
}

.selected-container {
  margin-top: 20px;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  color: white;
}

.placeholder {
  font-size: 14px;
  color: #999;
  margin-top: 10px;
}

.selected-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
}

.selected-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.el-button {
  background-color: transparent;
  border: 1px solid #409EFF;
  color: #409EFF;
  transition: all 0.3s ease;
  margin: 0 !important;

  &.active {
    background-color: #409EFF;
    color: white;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

::v-deep .el-drawer {
  background-color: #1a2535 !important;
  color: white !important;
}

.drawer-content {
  padding: 20px;
}

.grid-left-elDrawer {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.selection-count {
  margin-top: 20px;
  font-size: 14px;
  color: #ccc;
}

.box-flex-col {
  height: 100%;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  justify-content: space-between;
}

.isBlack {
  color: black;
}

.bgLine {
  border: 1px solid white;
}

.chart-footer {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 0 20px;

  .data-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 12px;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    min-width: 120px;

    .label {
      font-size: 12px;
      color: #a0a8c0;
      margin-bottom: 5px;
    }

    .value {
      font-size: 16px;
      font-weight: bold;
      color: #fff;

      &.highlight {
        color: #409EFF;
      }
    }

    .rate {
      font-size: 14px;
      color: #ffcc00;
      margin-left: 5px;
    }
  }
}

/* 修改表格背景色 */
:deep(.el-table) {
  background-color: transparent !important; /* 透明背景 */
  color: #fff; /* 文字颜色 */
}

/* 表头背景色 */
:deep(.el-table th) {
  background-color: rgba(0, 0, 0, 0.3) !important;
}

/* 表格行背景色 */
:deep(.el-table tr) {
  background-color: rgba(15, 19, 37, 0.4) !important;
}

/* 鼠标悬停行背景色 */
:deep(.el-table--enable-row-hover .el-table__body tr:hover > td) {
  background-color: rgba(64, 158, 255, 0.7) !important;
}

/* 单元格边框色 */
:deep(.el-table td, .el-table th) {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
}

/* 隐藏 el-table 的滚动条 */
:deep(.el-table__body-wrapper::-webkit-scrollbar) {
  display: none; /* Chrome/Safari */
}

:deep(.el-table__body-wrapper) {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}

</style>
